import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SubscriptionService } from '../../../services/subscription.service';
import { LoggedInUserService } from '../../../auth/logged.in.user';
import { AuthService } from '../../../auth/auth.service';
import { SubscriptionServiceType } from '../../../models/subscriptions/subscription.enums';

@Component({
    selector: 'stripe-payment',
    template: require('./stripe.payment.component.html')
})


export class StripePaymentComponent implements OnInit, OnChanges {

    @Input() selectedAccountId: number | null = null;
    @Input() submitText = 'Submit Payment';
    @Input() showRenewal = false;
    @Output() success = new EventEmitter<any>();

    @BlockUI() blockSubmit: NgBlockUI;

    stripe: any;
    elements: any;
    paymentElement: any;

    errorMessage = '';
    automaticRenewal = true;
    agreedToTandCs = false;
    showMustAgreeError = false;

    private paymentElementMounted = false;

    constructor(
        private subscriptionService: SubscriptionService,
        private loggedInUserService: LoggedInUserService,
        private readonly authService: AuthService
    ) {
        this.stripe = (window as any).Stripe;
    }

    private initialisePaymentForAccount() {
        this.destroyPaymentElement();

        const user = this.loggedInUserService.getCurrentUser();

        this.subscriptionService.createPaymentIntent({
            selectedAccount: this.selectedAccountId.toString(),
            automaticRenewal: !this.showRenewal,
            customerId: user.userId,
            email: user.email,
            subscriptionType: SubscriptionServiceType.Full
        }).subscribe((response: any) => {
            this.initPaymentElement(response.value.clientSecret);
        });
    }

    private initPaymentElement(clientSecret: string) {
        this.elements = this.stripe.elements({
            clientSecret,
            appearance: { theme: 'stripe' }
        });

        this.paymentElement = this.elements.create('payment');
        this.paymentElement.mount('#payment-element');
        this.paymentElementMounted = true;
    }

    private destroyPaymentElement() {
        if (this.paymentElement) {
            this.paymentElement.destroy();
            this.paymentElement = null;
        }
        this.elements = null;
        this.paymentElementMounted = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedAccountId && this.selectedAccountId) {
            this.initialisePaymentForAccount();
        }
    }

    ngOnInit() {

        //if (!this.showRenewal) {
        //    this.automaticRenewal = true;
        //}

        //const selectedAccount = localStorage.getItem(this.selectedAccount);
        //const user = this.loggedInUserService.getCurrentUser();

        //this.subscriptionService.createPaymentIntent({
        //    selectedAccount: selectedAccount,
        //    automaticRenewal: this.automaticRenewal,
        //    customerId: user.userId,
        //    email: user.email,
        //    subscriptionType: SubscriptionServiceType.Full
        //}).subscribe((response: any) => {

        //    const clientSecret = response.value.clientSecret;
        //    this.initPaymentElement(clientSecret);

        //});
    }


    async charge() {
        if (!this.agreedToTandCs) {
            this.showMustAgreeError = true;
            return;
        }

        this.showMustAgreeError = false;

        if (!this.showRenewal) {
            this.automaticRenewal = true;
        }

        this.blockSubmit.start(
            'Processing your payment. This may take up to a minute. Do not refresh the page.'
        );

        try {
            const result = await this.stripe.confirmPayment({
                elements: this.elements,
                confirmParams: {
                    // optional return URL for redirect-based flows
                    return_url: window.location.href,
                },
                // 'off_session' if auto-renew, else 'on_session'
                setup_future_usage: this.automaticRenewal ? 'off_session' : 'on_session',
                redirect: 'if_required', // keeps the flow in-page if possible
            });

            if (result.error) {
                this.blockSubmit.stop();
                this.errorMessage = result.error.message || 'Payment failed';
            } else if (result.paymentIntent.status === 'succeeded') {
                this.errorMessage = '';
                this.success.emit({
                    source: 0,
                    autoRenew: this.automaticRenewal,
                    threeDSecure: 0,
                    clientSecret: result.paymentIntent.client_secret
                });
            } else {
                this.blockSubmit.stop();
                this.errorMessage = `Unexpected payment status: ${result.paymentIntent && result.paymentIntent.status}`;
            }
        } catch (err) {
            this.blockSubmit.stop();
            console.error('Stripe confirmPayment error', err);
            this.errorMessage = 'Unexpected error confirming payment';
        } finally {
            //this.blockSubmit.stop();
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/card.payment/stripe.payment.component.ts